import styles from "../style";
import { Reveal } from "./reveal";
import { LogoIcon, s1, s2, s3 } from "../assets";
import { FiArrowRight, FiChevronRight } from "react-icons/fi";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Provide = () =>  {
  return (
  <div className={`bg-fourth w-full justify-center items-start flex flex-col md:flex-row py-20 px-10 gap-10`}>  
    <Reveal className="flex flex-col gap-4 items-start md:items-end py-40 pb-16">
      <h2 className="text-sm font-semibold text-primary">
        About Us
      </h2>
      <h2 className="py-4 xs:text-md text-md font-semibold text-primary max-w-[300px]">
        Aegis Education Group
      </h2>
    </Reveal>
    
    <div className="flex flex-col gap-4 items-start">
      <Reveal>
        <div className={`pb-14 flex flex-col items-start`}>
          <p className={`text-primary xs:text-mm text-sm text-start my-2 max-w-[800px]`}>
            Aegis Education Group provides consultancy led training and advisory support to help schools move from policy awareness to confident, consistent day to day practice.
          </p>

          <p className={`text-secondary xs:text-mm text-sm text-start my-6 max-w-[600px]`}>
            Aegis Education Group was founded by Emilianne Gathitu, a school leader, educator and safeguarding practitioner with international school experience across teaching, leadership, safeguarding, staff development and systems improvement.
          </p>

          <span className="xs:mb-6 border-b border-2 border-second w-[100px]"></span> 

          <div className="flex flex-row items-center justify-center gap-2 mt-6">
            <div className="w-[180px] h-[200px] md:w-[300px] md:h-[300px] rounded-lg overflow-hidden">
              <img src={s2} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="w-[180px] h-[200px] md:w-[300px] md:h-[300px] rounded-lg overflow-hidden">
              <img src={s3} alt="" className="w-full h-full object-cover" />
            </div>
          </div>         
        </div>        
      </Reveal>
      <Reveal>
        <Link to="/company">
          <motion.div 
            initial="initial"
            whileHover="hovered"
            className="flex flex-row items-center justify-center gap-2 cursor-pointer group relative overflow-hidden"
          >
            {/* Arrow icon container with animation */}
            <div className="w-[40px] h-[40px] relative mr-2 overflow-hidden">
              <motion.div 
                variants={{
                  initial: { y: 0 },
                  hovered: { y: "-100%" },
                }}
                className="absolute inset-0 bg-second flex items-center justify-center"
              >
                <FiArrowRight size={20} className="text-fourth" />
              </motion.div>
              <motion.div 
                variants={{
                  initial: { y: "100%" },
                  hovered: { y: 0 },
                }}
                className="absolute inset-0 bg-fourth flex items-center justify-center"
              >
                <FiArrowRight size={20} className="text-second" />
              </motion.div>
            </div>
            
            {/* Text with animation */}
            <div className="relative overflow-hidden">
              <motion.h2 
                variants={{
                  initial: { y: 0 },
                  hovered: { y: "-100%" },
                }}
                className="text-primary xs:text-mm text-mm font-semibold"
              >
                Our Story
              </motion.h2>
              <motion.h2 
                variants={{
                  initial: { y: "100%" },
                  hovered: { y: 0 },
                }}
                className="absolute inset-0 text-second xs:text-mm text-mm font-semibold"
              >
                Our Story
              </motion.h2>
            </div>
          </motion.div>
        </Link>
      </Reveal>
    </div>     
  </div>
)};

export default Provide;